import { render, staticRenderFns } from "./QuickscanRejected.vue?vue&type=template&id=3fe2661e"
import script from "./QuickscanRejected.vue?vue&type=script&lang=js"
export * from "./QuickscanRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports